import { useTranslation } from "react-i18next";
import Ownership from "../../enums/Ownership";
import { MessageBar, MessageBarBody } from "@fluentui/react-components";

interface IOwnershipMessageProps {
    ownership: Ownership;
    isNew: boolean;
}

export default function OwnershipMessage(props: IOwnershipMessageProps) {
    const { t } = useTranslation();

    return (
        <MessageBar intent="info">
            <MessageBarBody>
                {
                    props.isNew && props.ownership === Ownership.PERSONAL &&
                    t("folders.form.ownership.personal.new")
                }
                {
                    !props.isNew && props.ownership === Ownership.PERSONAL &&
                    t("folders.form.ownership.personal.existing")
                }
                {
                    props.isNew && props.ownership === Ownership.SHARED &&
                    t("folders.form.ownership.shared.new")
                }
                {
                    !props.isNew && props.ownership === Ownership.SHARED &&
                    t("folders.form.ownership.shared.existing")
                }
            </MessageBarBody>
        </MessageBar>
    );
}